module.exports = __webpack_public_path__ + "static/media/Huge Opportunities under one roof.02d2c126.png";